export default __webpack_public_path__ + "static/media/pai-logo.ab9b4b71.svg";